<template>
  <div>
    <div class="title_h1">報告書提出</div>
    <vab-collapse-info>
      <template slot="title">
        {{ getFieldValue('demandBaseIdModel.title', info) }}
        ［ {{ getFieldValue('purchaseOrderBaseIdModel.acceptOrderKey', info) }}
        ］
      </template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            <div class="flex_space width_100">
              <div>
                {{
                  getFieldValue(
                    'purchaseOrderBaseIdModel.buildingCdMbuildgpModel.blgsnmkj',
                    info
                  )
                }}
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">商品</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            <div class="flex_space width_100">
              <div>
                {{ getFieldValue('demandBaseIdModel.itemCdModel.itmnm', info) }}
              </div>
            </div>
          </vab-col>
        </vab-row>

        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">案件分類</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('demandBaseIdModel.businessForm', info),
                $divisions.consignmentWorkClassEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">進行部門</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{
                  getFieldValue(
                    'purchaseOrderBaseIdModel.purchaseOrderDepCdModel.orgkj',
                    info
                  )
                }}
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box rline">進行担当者</vab-col>
          <vab-col :span="8" class="word_box center_box">
            <div
              v-for="(item, index) in getFieldValue(
                'purchaseOrderBaseIdModel.purchaseOrderChargePersonModelList',
                info
              )"
              :key="index"
            >
              {{ getFieldValue('empnmkj', item.chargePersonCdModel) }}
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">納品予定年月</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              $dayjs(
                getFieldValue('demandBaseIdModel.contractEndDate', info)
              ).format('YYYY/MM')
            }}
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>

    <vab-form ref="form" :model="form">
      <div class="info_main">
        <div class="head_box flex_start flex_center_align">
          <!-- <img src="~@/assets/images/r16.png" alt="" /> -->
          <svg-icon icon-class="document_2_line"></svg-icon>
          <span class="hd_title">詳細情報</span>
        </div>
        <div class="sure_box top_info mb20">
          <vab-row class="row_box">
            <vab-col :span="4" class="title_box">商品明細</vab-col>
            <vab-col :span="20" class="word_box">
              {{
                getFieldValue(
                  'purchaseOrderBaseIdModel.itemCdModel.itmdtlnm',
                  info
                )
              }}
            </vab-col>
          </vab-row>
          <vab-row class="row_box">
            <vab-col :span="4" class="title_box">発注件名</vab-col>
            <vab-col :span="20" class="word_box">
              <div class="flex_space">
                <div>
                  {{
                    getFieldValue(
                      'purchaseOrderBaseIdModel.purchaseOrderName',
                      info
                    )
                  }}
                </div>
                <div class="sub_title">
                  （発注No：{{
                    getFieldValue(
                      'purchaseOrderBaseIdModel.acceptOrderNo',
                      info
                    )
                  }}）
                </div>
              </div>
            </vab-col>
          </vab-row>
          <vab-row class="row_box">
            <vab-col :span="4" class="title_box">提出状況</vab-col>
            <vab-col :span="20" class="word_box">
              {{
                getEnumText(
                  info.reportSubmitStatus,
                  $divisions.docSubmitStatusEnum
                )
              }}
            </vab-col>
          </vab-row>
        </div>
        <vab-file ref="vabFile">
          <div slot="h_title">報告書の提出を行ってください</div>
        </vab-file>
        <div class="sure_box">
          <vab-row class="row_box">
            <vab-col :span="4" class="title_box">協力会社コメント</vab-col>
            <vab-col :span="20" class="word_box nopadding2">
              <vab-textarea
                type="textarea"
                prop="comment"
                rows="5"
                maxlength="2340"
              ></vab-textarea>
            </vab-col>
          </vab-row>
          <vab-message
            ref="vabMessage"
            :title="'コメント履歴を閉じる'"
            class="noborder no_margin"
            :msg-type="$divisions.adjSourceClassEnum.enum_1.value"
          ></vab-message>
        </div>
        <div class="flex_end mg12">
          <vab-button :btn-list="btnList"></vab-button>
        </div>
      </div>
    </vab-form>
  </div>
</template>

<script>
  import { workImplementStatusInfo, update } from '@/api/workImplementStatus'
  import { querySc, scReportInit } from '@/api/requestDocuments'
  import mixinPage from '@/utils/mixinPage'
  import mixinSchedule from '@/utils/mixinSchedule'
  export default {
    name: 'PWS03G02',
    mixins: [mixinPage, mixinSchedule],
    data() {
      return {
        info: {},
        form: {},
        paramsData: {},
        scReport: [],
        btnList: [
          {
            name: '提出',
            icon: 'answer',
            type: 'button',
            // msg: this.$t(`validateMessage.${this.$messageCode.E00000363.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000452.name}`
            ),
            hidden: false,
            click: (row) => {
              this.submitBefore(row)
            },
          },
        ],
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
      async initData() {
        const loadingInstance = this.$baseColorfullLoading()
        try {
          // 実施状況ＩＤ
          let implementStatusId = this.$route.query?.implementStatusId
          if (implementStatusId) {
            this.implementStatusId = implementStatusId
            // 詳細はこちら
            await this.workImplementStatusInfo(implementStatusId)
            // SC報告書ー書類を取得
            await this.scReportInit()
            // SC報告書リスト取得
            await this.getQuerySc(implementStatusId)
          }
        } finally {
          loadingInstance.close()
        }
      },
      // 詳細はこちら
      async workImplementStatusInfo(implementStatusId) {
        const res = await workImplementStatusInfo(implementStatusId)
        this.info = res
        // 書類コメント
        this.setBookMessage(res?.comment)
      },
      //SC報告書リスト取得
      async getQuerySc(implementStatusId) {
        let docConfirmFlgList = [
          this.$divisions.docConfirmFlgEnum.enum_1.value,
          this.$divisions.docConfirmFlgEnum.enum_3.value,
        ]
        let list =
          (await querySc({
            implementStatusId: implementStatusId,
            docConfirmFlgList: docConfirmFlgList,
          })) || []
        // ページの統合に必要なデータ
        let data = {
          // 協力会社
          roleType: this.$divisions.notifyTypeEnum.work,
          // 報告書
          fileType: this.$divisions.bookTypeEnum.report,
          // 実施状況ＩＤ
          implementStatusId: implementStatusId,
          // 建物CD
          buildingCd: this.getFieldValue(
            'demandBaseIdModel.buildingCd',
            this.info
          ),
          // 受注キー
          acceptOrderKey: this.getFieldValue(
            'purchaseOrderBaseIdModel.acceptOrderKey',
            this.info
          ),
          // 発注基本ID
          purchaseOrderBaseId: this.getFieldValue(
            'purchaseOrderBaseIdModel.purchaseOrderBaseId',
            this.info
          ),
        }
        this.setOperationTypeFileList(list)
        this.realFileList = list
        if (list && list.length > 0) {
          this.initList = [...this.initList, ...list]
        }
        this.paramsData = data
        this.setFileList(list.length > 0)
      },
      // SC報告書ー書類を取得
      async scReportInit() {
        let list = await scReportInit(this.info)
        list.filter((item) => {
          item.docIdModel = {
            docId: item.docId,
            docName: item.docName,
          }
        })
        this.checkList = list
        this.initList = list
      },
      setFileList(showUpload) {
        let list = this.getFileList(this.initList, this.paramsData)
        this.$refs.vabFile.setList(list, this)
        this.$refs.vabFile.initData(
          {
            ...this.paramsData,
            purchaseOrderBaseId: this.getFieldValue(
              'purchaseOrderBaseIdModel.purchaseOrderBaseId',
              this.info
            ),
          },
          showUpload
        )
      },
      delFileListById(file) {
        let list = this.$baseLodash.cloneDeep(this.initList)
        for (let index = 0; index < list.length; index++) {
          let item = list[index]
          if (item.reportId == file.reportId) {
            list.splice(index, 1)
            index--
          }
        }
        this.initList = list
        let realFileList = this.$baseLodash.cloneDeep(this.realFileList)
        for (let index = 0; index < realFileList.length; index++) {
          let item = realFileList[index]
          if (item?.reportId == file?.reportId) {
            realFileList.splice(index, 1)
            index--
          }
        }
        this.realFileList = realFileList
        this.setFileList(this.realFileList.length > 0)
      },
      reloadBook() {
        this.initList = [...this.checkList]
        this.getQuerySc(this.implementStatusId)
      },
      // 提出前
      submitBefore(row) {
        const { check, docName } = this.checkBookRequired({
          roleType: this.$divisions.notifyTypeEnum.work,
        })
        if (!check) {
          this.$confirm({
            msg: this.format(
              this.$t(`validateMessage.${this.$messageCode.E00000323.name}`),
              docName
            ),
            enableCancel: false,
            yes: () => {},
          })
          return
        }
        this.$confirm({
          msg: this.format(
            this.$t(`validateMessage.${this.$messageCode.I00000301.name}`),
            row.name
          ),
          yes: () => {
            this.submitForm(row)
          },
        })
      },
      // 工事実施状況情報更新(協力会社)
      async submitForm(row) {
        let sumbitData = {
          ...this.info,
          comment: this.getBookMessage(this.form.comment),
        }
        let fileList = this.$baseLodash.cloneDeep(this.initList)
        let scReportModelList = fileList.filter((item) => item.fileName)
        scReportModelList.filter((item) => {
          delete item['dlnBtnList']
          delete item['showStateList']
          delete item['fileList']
          delete item['delCheck']
        })
        sumbitData.scReportModelList = scReportModelList
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await update(sumbitData)
          if (!res) {
            this.msgSuccess(row.word)
            this.$closePage(this.$route.path)
            this.$routerPushAndReload({
              path: '/rep/PWS03G01',
              refresh: 'PWS03G01',
            })
          }
        } finally {
          loadingInstance.close()
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tableInfo {
    overflow: hidden;
    border: 1px solid #d1dae1;
    border-radius: $base-border-radius3;
    .ts_box {
      padding: 10px 12px;
      background: #fff;
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #003350;
      }
    }
  }
</style>
